import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DebounceInput } from 'react-debounce-input';
import { FilterContext } from './context';
import getPastedInput from './getPastedInput';
import { SearchIcon } from '@pattern-library/icon';
import { XBoldIcon } from '@pattern-library/icon';
const propTypes = {
  className: PropTypes.string,
  /**
   * Label for search input
   */
  label: PropTypes.string,
  /**
   * Caption for search input
   */
  caption: PropTypes.string,
  /**
   * Placeholder text for search input
   */
  placeholder: PropTypes.string,
  /**
   * Fields within row values to search
   */
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Amount of time to debounce the search input in milliseconds
   */
  debounceTimeout: PropTypes.number
};
const defaultProps = {
  label: 'Search',
  placeholder: 'Type to filter…',
  debounceTimeout: 300
};
export default class DataGridFilterSearch extends Component {
  constructor() {
    super(...arguments);
    this.handleInputChange = event => {
      const {
        onUpdateSearch
      } = this.context;
      onUpdateSearch(event.target.value.trim());
    };
    this.handleInputPaste = event => {
      const {
        onUpdateSearch
      } = this.context;
      const pastedText = getPastedInput(event);
      onUpdateSearch(pastedText);
    };
    this.handleClear = () => {
      const {
        onUpdateSearch
      } = this.context;
      this.setState({
        query: ''
      });
      onUpdateSearch('');
      this.queryInput.focus();
    };
  }
  componentDidMount() {
    const {
      registerSearchFilter
    } = this.context;
    const {
      keys
    } = this.props;
    registerSearchFilter(keys);
  }
  render() {
    const {
      searchQuery
    } = this.context;
    const {
      className,
      label,
      caption,
      placeholder,
      debounceTimeout
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: cx('search-container', className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "asc-form-group asc-search "
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "data-grid-filter-search",
      className: "asc-form-label"
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "asc-input-wrapper"
    }, /*#__PURE__*/React.createElement(DebounceInput, {
      id: "data-grid-filter-search",
      inputRef: input => {
        this.queryInput = input;
      },
      className: "asc-form-input",
      type: "text",
      "data-qa": "data-grid-filter-search",
      placeholder: placeholder,
      onChange: this.handleInputChange,
      onPaste: this.handleInputPaste,
      debounceTimeout: debounceTimeout,
      value: searchQuery
    }), /*#__PURE__*/React.createElement("div", {
      className: "asc-data-grid-search-icon-container"
    }, searchQuery.length ? /*#__PURE__*/React.createElement("button", {
      className: "asc-data-grid-search-clear",
      onClick: this.handleClear
    }, /*#__PURE__*/React.createElement(XBoldIcon, {
      size: "sm",
      color: "current"
    }), /*#__PURE__*/React.createElement("span", {
      className: "asc-acc-hidden"
    }, "clear search")) : /*#__PURE__*/React.createElement(SearchIcon, {
      size: "sm",
      color: "gray"
    }))), caption && /*#__PURE__*/React.createElement("p", {
      className: "asc-search-caption"
    }, caption)));
  }
}
DataGridFilterSearch.propTypes = propTypes;
DataGridFilterSearch.defaultProps = defaultProps;
DataGridFilterSearch.contextType = FilterContext;